export type TipoExecucaoJob = 1 | 2 | 3

export const TipoExecucaoJobValores = {
  Diaria: 1 as TipoExecucaoJob,
  Intervalo: 2 as TipoExecucaoJob,
  Manual: 3 as TipoExecucaoJob,
} as const

export const TipoExecucaoJobRotulo: Record<TipoExecucaoJob, string> = {
  1: 'Diária',
  2: 'Por período',
  3: 'Manual',
}

export interface JobDefinicao {
  id: number
  codigo: string
  nome: string
  descricao?: string | null
  tipoExecucaoCodigo: TipoExecucaoJob
  tipoExecucaoDescricao: string
  horarioDiario?: string | null
  intervaloMinutos?: number | null
  ativo: boolean
  dataCorteInicial?: string | null
  diasRetroativos: number
  ultimaExecucaoInicio?: string | null
  ultimaExecucaoFimSucesso?: string | null
  proximaExecucaoEstimada?: string | null
}

export interface AtualizarJobScheduleDto {
  tipoExecucaoCodigo: TipoExecucaoJob
  horarioDiario?: string | null
  intervaloMinutos?: number | null
  diasRetroativos?: number | null
}

export interface JobExecucaoHistorico {
  id: number
  status: string
  mensagemErro?: string | null
  dataCriacao: string
  dataInicio?: string | null
  dataFim?: string | null
  resumoJson?: string | null
}

export interface JobExecutarResposta {
  id: number
  tipo: string
  status: string
  mensagemErro?: string | null
  dataCriacao: string
  dataInicio?: string | null
  dataFim?: string | null
  temArquivo: boolean
  nomeArquivo?: string | null
}
